export default {"src":"/_next/static/media/life-span-icon.cea4b000.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};